/**
 * Частые вопросы.
 *
 * Один и тот же текст живёт в трёх местах: в разметке главной, в заглушке
 * `index.html` для краулеров без JS и в `FAQPage` из JSON-LD там же. Расхождение
 * между видимым текстом и разметкой поисковики считают нарушением, поэтому
 * список лежит здесь, а `faq.test.ts` следит, что копии в `index.html` совпадают.
 */
export interface FaqItem {
  q: string
  a: string
}

export const FAQ: FaqItem[] = [
  {
    q: 'Нужна ли участникам регистрация?',
    a: 'Нет. Человек сканирует QR-код с экрана или вводит код эфира — и сразу отвечает. Ни почты, ни пароля, ни установки приложения.',
  },
  {
    q: 'Сколько человек выдержит зал?',
    a: 'Эфир рассчитан на зал в несколько сотен человек: ответы и реакции копятся на сервере и уходят на экраны пачками несколько раз в секунду, а не на каждое нажатие.',
  },
  {
    q: 'Что будет, если у участника пропадёт связь?',
    a: 'Телефон переподключится сам и догонит текущий вопрос, а ответ, отправленный в момент обрыва, дождётся связи и уйдёт следом.',
  },
  {
    q: 'Можно ли показывать вопросы на проекторе?',
    a: 'Да, для этого есть отдельный экран эфира: на нём крупно видно вопрос, QR-код для опоздавших и результат. Правильные ответы до их раскрытия остаются только в пульте ведущего.',
  },
  {
    q: 'Сколько это стоит?',
    a: 'Нисколько. clapme бесплатный, счёт заводить не нужно.',
  },
]
